/* eslint-disable import/no-deprecated */
import * as Constants from '../../constants';
import { ApiEndpoints } from '../../constants/ApiActions';
// constants
import { AudioPlayerActions } from '../../constants/AudioPlayer';
import { ScreenKeys } from '../../constants/Screen';
import Api from '../../lib/Api';
import { isIE11 } from '../../lib/CapabilitiesUtils';
import {
  getTestAudioAdId,
  getTestMode,
  getTestVideoAdId,
} from '../../lib/configuration/TunerVarUtils';
import { getFromMap } from '../../lib/CoreUtils';
import {
  generateClientCorrelationId,
  getCurrentListenerIdFromState,
  isAnonymousListener,
  isListenerAdFreeSkip,
  listenerIsBasic,
  shouldCurrentListenerGetAds,
} from '../../lib/ListenerUtils';
import { getTrackStationId, getTrackType, isArtistMessage } from '../../lib/PlaylistTrackUtils';
import { createReducer } from '../../lib/ReducerUtils';
import { isStationVoiceTrack } from '../../lib/VoiceTrackUtils';
import { thunkify, tryCall } from '../../sagas/Helpers';
import { taskManagerSpawnFactory } from '../../sagas/Helpers/SpawnedTaskManager';
import { putAndWait } from '../../sagas/TaskManager';
import Logger from '../../tools/Logger';
import * as Utils from '../../utils';
import { getInDomain } from '../externalUtils';

export {
  Api,
  ApiEndpoints,
  AudioPlayerActions,
  Constants,
  createReducer,
  generateClientCorrelationId,
  getCurrentListenerIdFromState,
  getFromMap,
  getInDomain,
  getTestAudioAdId,
  getTestMode,
  getTestVideoAdId,
  getTrackStationId,
  getTrackType,
  isAnonymousListener,
  isArtistMessage,
  isIE11,
  isListenerAdFreeSkip,
  isStationVoiceTrack,
  listenerIsBasic,
  Logger,
  putAndWait,
  ScreenKeys,
  shouldCurrentListenerGetAds,
  taskManagerSpawnFactory,
  thunkify,
  tryCall,
  Utils,
};
